'use client';

import {css} from '@panda/css';
import {CJKLocales} from '@i18n/config';
import {PropsWithChildren} from 'react';
import {Stack} from '@eds-web/react';
import {useLocale} from '@epic-mw/i18n';
import {Container, Promotions, PurchaseProvider} from '@/components';
import {useCommonComponentContext} from '@/context/ComponentContext';
import {RedeemedBannerTrigger} from './RedeemedBannerTrigger';
import {useAccountStore} from '@/hooks';

export default function SpendPage({children}: PropsWithChildren) {
	const locale = useLocale();
	const {LoadingComponent} = useCommonComponentContext();
	const {isLoading: accountLoading} = useAccountStore();

	return accountLoading ? (
		<LoadingComponent />
	) : (
		<PurchaseProvider
			products={{
				// temp hard code
				pinnedProducts: [
					{
						sandboxId: 'fn',
						offerIds: [
							'ede05b3c97e9475a8d9be91da65750f0',
							'559f2ba95f874ec987d0ebfd2cc9c70a',
							'd900ad5da7ec4eac86918bcfa0c3e698',
							'4daadb392f1c4ee2b5a3af443e614d2a'
						]
					}
				]
			}}>
			<RedeemedBannerTrigger />

			<Container
				pt="48px"
				pb="80px"
				minH="690px"
				display="grid"
				className={CJKLocales.includes(locale) ? css({wordBreak: 'break-all'}) : ''}
				width={{base: 'calc(100% - 48px)', md: '75%'}}>
				<Stack gap={48}>{children}</Stack>
			</Container>

			<Promotions />
		</PurchaseProvider>
	);
}
